import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import AuthTenantLoader from '../../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../../error/AuthTenantPageError';
import { tenant_auth_actions_helper } from '../../../../actions/actions_helper';
import { fail_retrieve_budget_allocation_main_details, loading_retrieve_budget_allocation_main_details, reset_retrieve_budget_allocation_main_details, success_retrieve_budget_allocation_main_details } from '../../../../reducers/auth_tenant/retrieve_budget_allocation_main_details_Slice';
import { RETRIVE_SPECIFIC_ALLOCATIONS_FOR_BUDGET_API } from '../../../../api/api_data';
import { RETRIEVE_TENANT_BUDGET_ALLOCATION_DETAILS_ERROR_MSG, RETRIEVE_TENANT_BUDGET_ALLOCATION_DETAILS_SUCCESS_MSG } from '../../../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { formatNumber, formatToSentenceCase, messageToast } from '../../../../utils/Utils';
import * as app_consts from "../../../../utils/app_consts";
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, Col, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent, Row } from '../../../../components/Component';
import { Badge, Card } from 'reactstrap';
import AuthTenantNoData from '../../../error/AuthTenantNoData';
import AddSalesRepToBudgetAllocationModal from '../../../../components/modal/AddSalesRepToBudgetAllocationModal';
import moment from 'moment';
import { download, generateCsv, mkConfig } from 'export-to-csv';

const AgencyAllocationsData = ({ tenant_info, user_info }) => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page_data, setPageData] = useState();
  const [sm, updateSm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const [add_allocation_modal, setAddAllocationModal] = useState(false);

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = page_data?.sales_rep_allocations?.slice(indexOfFirstItem, indexOfLastItem);

  const dispatch = useDispatch();
  const { id } = useParams();

  useEffect(() => {
    retrieve_allocation_details();
  }, []);

  const retrieve_allocation_details = () => {
    setError("");
    setLoading(true);
    dispatch(tenant_auth_actions_helper(loading_retrieve_budget_allocation_main_details, success_retrieve_budget_allocation_main_details, fail_retrieve_budget_allocation_main_details, RETRIEVE_TENANT_BUDGET_ALLOCATION_DETAILS_ERROR_MSG, RETRIEVE_TENANT_BUDGET_ALLOCATION_DETAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIVE_SPECIFIC_ALLOCATIONS_FOR_BUDGET_API}/${id}`));
  };

  // Listen
  const retrieve_budget_allocation_main_details_listener = useSelector((state) => state.retrieve_budget_allocation_main_details.retrieve_budget_allocation_main_details);

  useEffect(() => {
    if (retrieve_budget_allocation_main_details_listener.status !== app_consts.IDLE)
    {
      if (retrieve_budget_allocation_main_details_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_budget_allocation_main_details_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_budget_allocation_main_details_listener.message);
          messageToast(retrieve_budget_allocation_main_details_listener.message, app_consts.FAIL);
        } else if (retrieve_budget_allocation_main_details_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_budget_allocation_main_details_listener.data);

          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_budget_allocation_main_details());
      }
    }
  }, [retrieve_budget_allocation_main_details_listener]);

  const open_add_allocation_modal = () => {
    setAddAllocationModal(true);
  };

  const close_add_allocation_modal = () => {
    setAddAllocationModal(false);
  };

  const successAddAllocationFunction = () => {
    close_add_allocation_modal();
    retrieve_allocation_details();
  };

  const export_to_csv = () => {
    const cur_dt = moment().format("DD-MM-YYYY h:mm:ss a");

    // Define CSV headers
    const csv_headers = [
      "Sales Rep Name",
      "Allocated Value",
      "Used Value",
      "Remaining Value",
    ];

    // Transform allocations
    const rows = page_data?.sales_rep_allocations.map((item) => ({
      "Sales Rep Name": item.sales_rep.name,
      "Allocated Value": item.sales_bud_allocation.value,
      "Used Value": item.sales_bud_allocation.used,
      "Remaining Value": item.sales_bud_allocation.remaining,
    })) || [];

    // Totals row
    const totals = {
      "Sales Rep Name": "TOTAL",
      "Allocated Value": page_data?.budget_allocation?.sum_of_allocations
        ? `${formatNumber(parseFloat(page_data?.budget_allocation?.sum_of_allocations).toFixed(2))} ZMW`
        : "--",
      "Used Value": page_data?.budget_allocation?.used_value
        ? `${formatNumber(parseFloat(page_data?.budget_allocation?.used_value).toFixed(2))} ZMW`
        : "--",
      "Remaining Value": page_data?.budget_allocation?.remaining_value
        ? `${formatNumber(parseFloat(page_data?.budget_allocation?.remaining_value).toFixed(2))} ZMW`
        : "--",
    };

    rows.push(totals);

    // Dates row (align with headers)
    const startDate = page_data?.budget_allocation?.start_date
      ? moment(page_data.budget_allocation.start_date).format("DD-MM-YYYY")
      : "--";

    const endDate = page_data?.budget_allocation?.end_date
      ? moment(page_data.budget_allocation.end_date).format("DD-MM-YYYY")
      : "--";

    const datesRow = {
      "Sales Rep Name": "Period",
      "Allocated Value": startDate,
      "Used Value": "→",
      "Remaining Value": endDate,
    };

    rows.push(datesRow);

    // CSV config
    const options = mkConfig({
      fieldSeparator: ",",
      quoteStrings: '"',
      showLabels: true,
      filename: `${page_data?.budget_allocation?.name} Allocations as of ${cur_dt}`,
      columnHeaders: csv_headers,
    });

    const csv = generateCsv(options)(rows);
    download(options)(csv);
  };

  return (
    <>
      {loading ? (
        <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Allocation Details..." />
      ) : error ? (
        <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
      ) : (
        <>
          <Block style={{ marginTop: '20px' }}>
            <Row className="g-gs" style={{ marginBottom: '20px' }}>
              {/* Stats Cards */}
              <Col xxl="3" sm="6" style={{ marginBottom: '20px' }}>
                <Card style={{
                  borderRadius: '8px',
                  border: '1px solid #e5e9f2',
                  transition: 'all 0.3s ease',
                  marginBottom: 0,
                  height: '100%',
                  ':hover': {
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                    transform: 'translateY(-2px)'
                  }
                }}>
                  <div style={{ padding: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div>
                        <h6 style={{ fontSize: '14px', color: '#6c757d', marginBottom: '8px' }}>Total Value</h6>
                        <h2 style={{ fontSize: '24px', fontWeight: '600', margin: 0 }}>{page_data?.budget_allocation?.value ? `${formatNumber(parseFloat(page_data?.budget_allocation?.value)?.toFixed(2))} ZMW` : "--"}</h2>
                      </div>
                    </div>
                  </div>
                </Card>
              </Col>
              <Col xxl="3" sm="6" style={{ marginBottom: '20px' }}>
                <Card style={{
                  borderRadius: '8px',
                  border: '1px solid #e5e9f2',
                  transition: 'all 0.3s ease',
                  marginBottom: 0,
                  height: '100%',
                  ':hover': {
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                    transform: 'translateY(-2px)'
                  }
                }}>
                  <div style={{ padding: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div>
                        <h6 style={{ fontSize: '14px', color: '#6c757d', marginBottom: '8px' }}>Total Allocated</h6>
                        <h2 style={{ fontSize: '24px', fontWeight: '600', margin: 0 }}>{page_data?.budget_allocation?.sum_of_allocations ? `${formatNumber(parseFloat(page_data?.budget_allocation?.sum_of_allocations)?.toFixed(2))} ZMW` : "--"}</h2>
                      </div>
                    </div>
                  </div>
                </Card>
              </Col>
              <Col xxl="3" sm="6" style={{ marginBottom: '20px' }}>
                <Card style={{
                  borderRadius: '8px',
                  border: '1px solid #e5e9f2',
                  transition: 'all 0.3s ease',
                  marginBottom: 0,
                  height: '100%',
                  ':hover': {
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                    transform: 'translateY(-2px)'
                  }
                }}>
                  <div style={{ padding: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div>
                        <h6 style={{ fontSize: '14px', color: '#6c757d', marginBottom: '8px' }}>Total Used</h6>
                        <h2 style={{ fontSize: '24px', fontWeight: '600', margin: 0 }}>{page_data?.budget_allocation?.used_value ? `${formatNumber(parseFloat(page_data?.budget_allocation?.used_value)?.toFixed(2))} ZMW` : "--"}</h2>
                      </div>
                    </div>
                  </div>
                </Card>
              </Col>
              <Col xxl="3" sm="6" style={{ marginBottom: '20px' }}>
                <Card style={{
                  borderRadius: '8px',
                  border: '1px solid #e5e9f2',
                  transition: 'all 0.3s ease',
                  marginBottom: 0,
                  height: '100%',
                  ':hover': {
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                    transform: 'translateY(-2px)'
                  }
                }}>
                  <div style={{ padding: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div>
                        <h6 style={{ fontSize: '14px', color: '#6c757d', marginBottom: '8px' }}>Remaining Value</h6>
                        <h2 style={{ fontSize: '24px', fontWeight: '600', margin: 0 }}>{page_data?.budget_allocation?.remaining_value ? `${formatNumber(parseFloat(page_data?.budget_allocation?.remaining_value)?.toFixed(2))} ZMW` : "--"}</h2>
                      </div>
                    </div>
                  </div>
                </Card>
              </Col>
            </Row>

            <BlockHead size="sm" className="mt-4">
              <BlockBetween>
                <BlockHeadContent>
                  <BlockTitle page> Allocations</BlockTitle>
                  <BlockDes className="text-soft">
                    <p>{!(loading || error) && `Total Allocations ${page_data?.sales_rep_allocations?.length}` || "0"}</p>
                  </BlockDes>
                  {!(loading) && (
                    <div className="mt-2">
                      <Link
                        onClick={(e) => {
                          e.preventDefault();
                          retrieve_allocation_details();
                        }}
                      >
                        <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                          <span>Refresh List</span>
                        </Button>
                      </Link>
                    </div>
                  )}
                </BlockHeadContent>
                {
                  !(loading || error) && (
                    <>
                      <BlockHeadContent>
                        <div className="toggle-wrap nk-block-tools-toggle">
                          <a
                            href="#more"
                            className="btn btn-icon btn-trigger toggle-expand me-n1"
                            onClick={(ev) => {
                              ev.preventDefault();
                              updateSm(!sm);
                            }}
                          >
                            <Icon name="more-v"></Icon>
                          </a>
                          <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                            <ul className="nk-block-tools g-3">
                              <li>
                                <div className="form-control-wrap">
                                  <div className="form-icon form-icon-right">
                                    <Icon name="search"></Icon>
                                  </div>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="default-04"
                                    value={searchTerm}
                                    onChange={e => setSearchTerm(e.target.value)}
                                    placeholder="Search for Allocation"
                                  />
                                </div>
                              </li>
                              {
                                (user_info?.roles?.includes(app_consts.ADD_BUDGET_ALLOCATION) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                                  <>
                                    <Button color="light" size="sm" onClick={() => export_to_csv()}>
                                      Export to CSV
                                    </Button>
                                  </>
                                )
                              }
                              {
                                (user_info?.roles?.includes(app_consts.ADD_BUDGET_ALLOCATION) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                                  <>
                                    <li className="nk-block-tools-opt">
                                      <Button
                                        className="toggle btn-icon d-md-none"
                                        color="primary"
                                        onClick={() => {
                                          open_add_allocation_modal();
                                        }}
                                      >
                                        <Icon name="plus"></Icon>
                                      </Button>
                                      <Button
                                        className="toggle d-none d-md-inline-flex"
                                        color="primary"
                                        onClick={() => {
                                          open_add_allocation_modal();
                                        }}
                                      >
                                        <Icon name="plus"></Icon>
                                        <span>Add Allocation</span>
                                      </Button>
                                    </li>
                                  </>
                                )
                              }
                            </ul>
                          </div>
                        </div>
                      </BlockHeadContent>
                    </>
                  )
                }
              </BlockBetween>
            </BlockHead>

            {
              page_data?.sales_rep_allocations && page_data?.sales_rep_allocations?.length > 0 ?
                <>
                  <div className="nk-tb-list is-separate is-medium mb-3">
                    <DataTableHead className="nk-tb-item">
                      <DataTableRow>
                        <span className="sub-text">Name</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span className="sub-text">Allocated Value</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span className="sub-text">Used Value</span>
                      </DataTableRow>
                      <DataTableRow size="lg">
                        <span className="sub-text">Remaining Value</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span className="sub-text">Action</span>
                      </DataTableRow>
                    </DataTableHead>
                    {currentItems.length > 0
                      ? currentItems.map((item) => (
                        <DataTableItem key={item.id}>
                          <DataTableRow>
                            <Link >
                              <div className="user-card">
                                <div className="user-info">
                                  <span className="tb-lead">
                                    {item?.sales_rep?.name || "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                  </span>
                                </div>
                              </div>
                            </Link>
                          </DataTableRow>
                          <DataTableRow>
                            <div className="user-card">
                              <div className="user-info">
                                <span>{item?.sales_bud_allocation?.value ? `${formatNumber(parseFloat(item?.sales_bud_allocation?.value)?.toFixed(2))} ZMW` : "--"}</span>
                              </div>
                            </div>
                          </DataTableRow>
                          <DataTableRow>
                            <div className="user-card">
                              <div className="user-info">
                                <span>{item?.sales_bud_allocation?.used ? `${formatNumber(parseFloat(item?.sales_bud_allocation?.used)?.toFixed(2))} ZMW` : "--"}</span>
                              </div>
                            </div>
                          </DataTableRow>
                          <DataTableRow>
                            <div className="user-card">
                              <div className="user-info">
                                <span>{item?.sales_bud_allocation?.remaining ? `${formatNumber(parseFloat(item?.sales_bud_allocation?.remaining)?.toFixed(2))} ZMW` : "--"}</span>
                              </div>
                            </div>
                          </DataTableRow>
                          <DataTableRow className="nk-tb-col-tools">
                            <div className="tb-odr-btns d-none d-sm-inline">
                              <Link >
                                <Button color="primary" size="sm" className="btn btn-dim">
                                  View
                                </Button>
                              </Link>
                            </div>
                            <Button className="btn-pd-auto d-sm-none">
                              <Icon name="chevron-right"></Icon>
                            </Button>
                          </DataTableRow>
                        </DataTableItem>
                      ))
                      : null}
                  </div>
                  {currentItems.length > 0 && (
                    <div className="mt-3">
                      <PaginationComponent
                        itemPerPage={itemPerPage}
                        totalItems={page_data?.sales_rep_allocations?.length}
                        paginate={paginate}
                        currentPage={currentPage}
                      />
                    </div>
                  )}
                </>
                :
                <>
                  <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Allocations Found"} />
                </>
            }
            <AddSalesRepToBudgetAllocationModal isOpen={add_allocation_modal} successFunction={successAddAllocationFunction} closeModal={close_add_allocation_modal} tenant_info={tenant_info} user_info={user_info} />
          </Block>
        </>
      )
      }
    </>
  );
};

export default AgencyAllocationsData;;;